export const generateHexColor = () => {
  const hexColor = Math.floor(Math.random() * 16777215).toString(16);
  return `#${hexColor}`;
};

export const generateId = () => {
  const id = Math.floor(Math.random() * 100000000);
  return id.toString().padStart(8, '0');
};
